import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';
import { useNavigate} from "react-router-dom";
import Cookie from "cookie-universal";
import Form from 'react-bootstrap/Form';
import Location from '../../../Components/location/Location';
import axios from 'axios';
import { baseURL } from '../../../Api/Api';
export default function OrderInfo(){
    const[mobileN,setMobileN]=useState("");
    const[myLocation,setMyLocation]=useState({ latitude: null, longitude:null});
    const[error,setError]=useState(false); 

     //Navigate
    const Navigate=useNavigate();
    const[show,setShow]=useState(true);

    //cookie
      const cookie=Cookie();

    var priceTotal=0;
    const handleClose = () => Navigate('/' , {replace:true});

    //local storage for cartInfo
    const getItems=JSON.parse(localStorage.getItem('product')) || [];
    const countTotal=localStorage.getItem('countTotal') || 0;

    //Mapping data for show in order info
    const dataShow=getItems?.map((item,key)=>
     <div className='details-order-div d-flex justify-content-between ' key={key} >
        <div> <h5>{item.title}</h5></div>
        <div> <h5>{item.discount!=0?"Price: $" + item.discount:"Price: $" + item.price}</h5></div>
        <div> <h5>{item.count?"count: " + item.count:"count: " + 1}</h5></div>
     </div>);

    //mapping data for send to backend
    const dataOrder = getItems?.map((item) => ({
        product_id: item.id,
        count: item.count ? item.count : 1,
    }));
     //forEach
     getItems.forEach((item)=>{
        if(item.discount ==0){
            priceTotal+=Number(item.price) * item.count;
        }else{
            priceTotal+=Number(item.discount) * item.count;
        }
     });
     
     async function handleOrder(e){
          if(!mobileN || myLocation.latitude==null || myLocation.longitude==null) {
            e.preventDefault();
            setError(true);   
             setTimeout(() => {
                    setError(false);
                }, 4000);  
          }
          else{
          try {
            const res = await axios.post(`${baseURL}/cart`, {
                "items": dataOrder,  // مصفوفة المنتجات فقط
                "location": `${myLocation.latitude}-${myLocation.longitude}`,  // location كـ string
                "mobile": mobileN,  // mobile كـ string
                "status": "pending...",
                 "result": "Your request is being processed"
            }, {
                headers: {
                    authorization: 'Bearer ' + cookie.get("e-commerce"),
                }
            });
            localStorage.clear();
            window.location.pathname='/';
           }
           catch(err){
            if(err.response.status==422){
                setError(true);
                setTimeout(() => {
                    setError(false);
                }, 4000);
            }
           }
          }
          };
           
    
    return(
        <div className='web-back-ground'>
           <Modal  show={show} onHide={handleClose}>
                 <Modal.Header closeButton>
                   <Modal.Title style={{color:'#ff914d'}}>Order</Modal.Title>
                 </Modal.Header>
                 <Modal.Body className='parent-cart text-center p-3 pb-0'
                  style={{borderBlock:'2px solid #ff914d'}}>
                    <div>
                    {dataShow}
                    </div>
                     <div className='d-flex flex-column align-items-start mt-2 gap-2'>
                        <h5>The total count is: <span style={{color:'#ff914d'}}>{countTotal}</span></h5>
                        <h5>The total price is: <span style={{color:'#ff914d'}}>${priceTotal.toFixed(2)}</span> </h5>
                     </div>
                     <div className='d-flex flex-column gap-3 align-items-start m-2 '>
                        <div className='d-flex  gap-3 align-items-center justify-content-start'>
                        <label style={{fontWeight:'bolder'}}>Contact Number</label>
                     <Form.Control type="text" placeholder="phone Number" required
                      value={mobileN} onChange={(e)=>setMobileN(e.target.value)}
                     style={{width:'60%',border:'2px solid #ff914d',borderRadius:'8px'}}/>
                       </div>
                       <Location location={setMyLocation}/>
                     </div>
                </Modal.Body>
                 <Modal.Footer className='d-flex justify-content-end gap-4'>
                  {error && <p style={{color:'red'}}>Please enter the required fields</p>}
                   <Button className='btn-order'  onClick={handleOrder}  >
                     Send order
                   </Button>
                 </Modal.Footer>
               </Modal>
               </div>
    );
}

        